function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class tieredFilterEntity.
 *
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '../loader';
import { actionRegistrar } from '../../../actions/entityActionRegistrar';
import TieredSelect from './tieredSelect';

/*
 *   The idea in this filter selector is that you are filtering from one
 *   entity to another.  Meaning for instance, if you want to filter Issues
 *   with IssueSeverity, you are filtering from IssueSeverity to Issue.
 *
 *   Thus, fromEntity === IssueSeverity state and actions,
 *     toEntity === Issue state and actions.
 *
 *   Note that the actual entity names are camelCase.
 */
class TieredFilterEntity extends Component {
  constructor(props) {
    // console.log('constructing', props.fromEntity);
    super(props);
    this.handleFilter = this.handleFilter.bind(this);
  }
  componentDidMount() {
    const {
      fromEntity,
      fromEntityActions
    } = this.props;
    fromEntityActions.serverIndex(fromEntity.indexQuery);
  }
  componentDidUpdate() {
    const {
      fromEntity,
      fromEntityActions
    } = this.props;
    fromEntityActions.serverIndex(fromEntity.indexQuery);
  }
  attributeName() {
    const {
      fromEntity,
      filterAttributeName
    } = this.props;
    return filterAttributeName || fromEntity.entity;
  }
  extractOptions() {
    const {
      fromEntity: {
        list
      },
      getOptionName
    } = this.props;
    const options = JSON.parse(JSON.stringify(list));

    // if getOptionName function is defined - get the new option name
    return getOptionName ? options.map(option => getOptionName(option)) : options;
  }
  handleFilter(values) {
    const {
      toEntity,
      toEntityActions
    } = this.props;
    const filters = _objectSpread({}, toEntity.indexQuery.filters);
    const attributeName = this.attributeName();
    let newFilters = {};
    // limit each filter value down to the essentials
    const filterVals = values.map(value => ({
      id: value.id,
      name: value.name || '',
      entity: value.entity || attributeName,
      sortOrder: value.sortOrder || 0
    }));
    newFilters = _objectSpread(_objectSpread({}, filters), {}, {
      [attributeName]: filterVals
    });
    // tell the server to get a new set of data given the new filters.
    toEntityActions.serverFilter(newFilters, toEntity.indexQuery);
  }
  render() {
    const {
      children,
      toEntity,
      fromEntity,
      onBack,
      label,
      multi
    } = this.props;
    const attributeName = this.attributeName();
    const options = this.extractOptions();
    const values = toEntity.indexQuery.filters[attributeName];
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 100
      }
    }, /*#__PURE__*/React.createElement(TieredSelect, {
      label: label,
      entity: fromEntity.entity,
      key: fromEntity.entity,
      value: values,
      data: options,
      onBack: onBack,
      onChange: this.handleFilter,
      multi: multi
    }, children, /*#__PURE__*/React.createElement(Loader, {
      loaded: !fromEntity.loading
    })));
  }
}
TieredFilterEntity.propTypes = {
  children: PropTypes.node.isRequired,
  toEntity: PropTypes.shape({
    entity: PropTypes.string,
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    })
  }).isRequired,
  toEntityActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  fromEntity: PropTypes.shape({
    loading: PropTypes.bool,
    entity: PropTypes.string,
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  fromEntityActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  label: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  multi: PropTypes.bool,
  getOptionName: PropTypes.func,
  filterAttributeName: PropTypes.string
};
TieredFilterEntity.defaultProps = {
  filterAttributeName: null,
  multi: true,
  getOptionName: null
};
const tieredFilterEntity = (toEntity, fromEntity, attributeName) => {
  // map the redux store/state into props for this component.
  const mapStateToProps = state => {
    const result = {};
    result.fromEntity = state[fromEntity];
    result.toEntity = state[toEntity];
    if (attributeName) {
      result.filterAttributeName = attributeName;
    }
    return result;
  };

  // map the redux dipsatch mechanism into actions prop for this component.
  const mapDispatchToProps = dispatch => {
    const result = {};
    const fromActions = actionRegistrar(fromEntity);
    if (fromActions) {
      result.fromEntityActions = bindActionCreators(fromActions, dispatch);
    }
    const toActions = actionRegistrar(toEntity);
    if (toActions) {
      result.toEntityActions = bindActionCreators(toActions, dispatch);
    }
    return result;
  };

  // This wraps and instance of an entity in ConnectedClass and
  // connects it to the subset of the redux state as well as the action set
  return connect(mapStateToProps, mapDispatchToProps)(TieredFilterEntity);
};
export default tieredFilterEntity;